import { render, staticRenderFns } from "./van-popup-stockInfo-688131.vue?vue&type=template&id=5111008e&scoped=true"
import script from "./van-popup-stockInfo-688131.vue?vue&type=script&setup=true&lang=js"
export * from "./van-popup-stockInfo-688131.vue?vue&type=script&setup=true&lang=js"
import style0 from "./van-popup-stockInfo-688131.vue?vue&type=style&index=0&id=5111008e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5111008e",
  null
  
)

export default component.exports